import type { Color } from "@mui/material";
import { amber, blue, blueGrey, deepPurple, green, indigo, purple, red, teal } from "@mui/material/colors";
import type { OrderStatus } from "@/api/order/_models/Order";

const ORDER_LIST_STATUS_CHIP_HUES: Record<OrderStatus, Color> = {
  Backordered: red,
  "Pending Allocation": blue,
  "Allocated to 3PL": teal,
  Shipped: indigo,
  Completed: green,
  Shortfall: red,
  Hold: deepPurple,
  Cancelled: blueGrey,
  Test: purple,
  Unknown: amber,
};

/** The hue for an order status: lifecycle runs cool to green, problems are red, Unknown is amber. */
export const orderListStatusChipHue = (status: OrderStatus): Color => {
  return ORDER_LIST_STATUS_CHIP_HUES[status];
};
